import { render, staticRenderFns } from "./UpBenefitsReport.vue?vue&type=template&id=1f5fdc62"
import script from "./UpBenefitsReport.vue?vue&type=script&lang=js"
export * from "./UpBenefitsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports